/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：984
 */

var r = require(/* 1405 */"./1405")
module.exports = function (e) {
  return new r(e)
}
